<template>
  <div class="vue-wrapper" :style="styles">
    <navbar></navbar>
    <main class="main-container">
      <div class="container placeholder" v-show="loading">
        <div
          class="placeholder__block"
          v-for="(block, index) in placeholderBlocks"
          :key="index"
        ></div>
      </div>
      <child/>
    </main>

    <controls></controls>
    <footer-block></footer-block>
  </div>
</template>

<script>
  import Navbar from '~/components/Navbar.vue';
  import FooterBlock from '~/components/Footer.vue';
  import { mapGetters } from 'vuex';
  import Controls from '../components/global/Controls.vue'

  export default {
    name: 'app-layout',

    components: {
      Controls,
      Navbar,
      FooterBlock,
    },
    data: function () {
      return {
      };
    },
    computed: {
      ...mapGetters({
        pageInfo: 'pages/pageInfo',
        loading: 'pages/loading',
      }),
      styles: function () {
        const backgroundImage = this.pageInfo.background_image ? 'url(/images/pages/' + this.pageInfo.name + '/' + this.pageInfo.background_image + ')' : 'none';
        const backgroundRepeat = this.pageInfo.background_repeat ? 'repeat' : 'no-repeat';
        const colorsText = this.pageInfo.colors_text || false;
        const colorsMain = this.pageInfo.colors_main || false;
        const colorsMain2 = this.pageInfo.colors_main2 || false;

        const styles = {
          'background-image': backgroundImage,
          'background-position': 'center top',
          'background-size': 'auto',
          'background-repeat-x': 'repeat',
          'background-repeat-y': backgroundRepeat,
        };

        if (colorsText) {
          styles['--text-color'] = colorsText;
        }
        if (colorsMain) {
          styles['--main-color'] = colorsMain;
        }
        if (colorsMain2) {
          styles['--main-color-2'] = colorsMain2;
        }

        return styles;
      },
      placeholderBlocks: function () {
        let blocks = [];
        try {
          blocks = JSON.parse(this.pageInfo.blocks);
        } catch (e) {
          blocks = [];
        }

        return blocks;
      },
    },
    watch: {
    },
    created () {
    },
  };
</script>
